// extracted by mini-css-extract-plugin
export default {"loginButton":"GoToLogin_loginButton__BOE+M"};